import React from 'react';
import { useState } from 'react';

import { useMinimalCartUi } from 'features/cart/hooks/use-minimal-cart-ui';
import { MenuReorderCard } from 'features/menu/components/menu-reorder-widget/menu-reorder-card';
import { MenuReorderDetailsDrawer } from 'features/menu/components/menu-reorder-widget/menu-reorder-details-drawer';
import { useLastOrderAvailableToReorder } from 'features/menu/components/menu-reorder-widget/use-last-order-available-to-reorder';
import { MinimalMenuReorderWidget } from 'features/menu/components/minimal-menu-reorder-widget/minimal-menu-reorder-widget';
import { StyleSheet } from 'react-native';

import { CenteredRowContainer } from 'components/layout/centered-row-container';
import { Box } from 'components/ui';
import { useExposeMinimalCartExperiment } from 'experiments/use-enable-minimal-cart-experiment';
import { CustomEventNames } from 'state/amplitude';
import { useReorder } from 'state/order/hooks/use-reorder';
import { spacing } from 'styles/constants';

const LegacyMenuReorderWidget = () => {
  const openDetailEventMessage = CustomEventNames.LAST_ORDER_DETAILS;
  const lastOrder = useLastOrderAvailableToReorder();
  const [isDetailsDrawerOpen, setIsDetailsDrawerOpen] = useState<boolean>(false);
  const toggleDetailsDrawer = () => setIsDetailsDrawerOpen(!isDetailsDrawerOpen);

  const { isReorderingDisabled } = useReorder(lastOrder);
  const isWidgetVisible = Boolean(lastOrder) && !isReorderingDisabled;

  useExposeMinimalCartExperiment(isWidgetVisible);

  if (!lastOrder || !isWidgetVisible) {
    return null;
  }

  return (
    <CenteredRowContainer>
      {isDetailsDrawerOpen ? (
        <MenuReorderDetailsDrawer
          order={lastOrder}
          showDrawer={isDetailsDrawerOpen}
          toggleDetailsDrawer={toggleDetailsDrawer}
          openDetailEventMessage={openDetailEventMessage}
        />
      ) : (
        <Box style={styles.cardWrapper}>
          <MenuReorderCard
            order={lastOrder}
            toggleDetailsDrawer={toggleDetailsDrawer}
            drawerIsOpen={isDetailsDrawerOpen}
          />
        </Box>
      )}
    </CenteredRowContainer>
  );
};

export const MenuReorderWidget = () => {
  const enableMinimalCartUi = useMinimalCartUi();

  return enableMinimalCartUi ? <MinimalMenuReorderWidget /> : <LegacyMenuReorderWidget />;
};

const styles = StyleSheet.create({
  cardWrapper: {
    padding: spacing.$4,
  },
});
